// extracted by mini-css-extract-plugin
export default {"root":"PlasmicModuleNav_root__5N3Z4"};